import { showErrorMessage } from 'actions/messages';
import {
  DEPOSITS_LOAD_SUCCESS,
  DEPOSITS_DEPOSIT_ATTRIBUTE_UPDATE,
  DEPOSITS_PAGE_CHANGE,
  DEPOSITS_DEPOSIT_LOAD_SUCCESS,
  DEPOSITS_DEPOSIT_PRINT_SUCCESS,
  DEPOSITS_DEPOSIT_PDF_VIEWER_CLOSE,
  DEPOSITS_USERS_LOAD_SUCCESS,
  DEPOSITS_DEPOSIT_EMAIL_MODAL_SHOW_SET,
} from 'actions/admin/deposits/action-types';
import { depositsApi } from 'services/api/deposits-api';
import { clientsApi } from 'services/api/clients-api';
import { push } from 'react-router-redux';

export const baseRoutePath = '/admin/invoices/deposit';

export function changePage(newPage) {
  return {
    type: DEPOSITS_PAGE_CHANGE,
    payload: newPage,
  };
}

export function loadDepositsRequest(page) {
  return (dispatch) => {
    return depositsApi.getDeposits(page).then((response) => {
      if (response.ok) {
        dispatch(loadDepositsSuccess(response.deposits));
        dispatch(changePage(page));
      } else {
        dispatch(showErrorMessage(response.errors));
      }

      return response;
    });
  };
}

export function loadDepositsSuccess(deposits) {
  return {
    type: DEPOSITS_LOAD_SUCCESS,
    payload: deposits,
  };
}

export function goToDeposit(depositId) {
  return (dispatch) => {
    dispatch(push(`${baseRoutePath}/${depositId}`));
  };
}

export function loadDepositRequest(depositId) {
  return (dispatch) => {
    return depositsApi.getDeposit(depositId).then((response) => {
      if (response.ok) {
        dispatch(loadDepositSuccess(response.deposit));
      } else {
        dispatch(showErrorMessage(response.errors));
      }

      return response;
    });
  };
}

export function loadDepositSuccess(deposit) {
  return {
    type: DEPOSITS_DEPOSIT_LOAD_SUCCESS,
    payload: deposit,
  };
}

export function markAsPaidRequest(depositId) {
  return (dispatch) => {
    return depositsApi.markDepositAsPaid(depositId).then((response) => {
      if (response.ok) {
        dispatch(
          updateCurrentDepositAttribute('status', response.deposit.status)
        );
      } else {
        dispatch(showErrorMessage(response.errors));
      }
    });
  };
}

export function updateCurrentDepositAttribute(attribute, value) {
  return {
    type: DEPOSITS_DEPOSIT_ATTRIBUTE_UPDATE,
    payload: { attribute, value },
  };
}

export function printDeposit(depositId) {
  return (dispatch) => {
    return depositsApi.getAsPdf(depositId).then((response) => {
      if (response.ok) {
        dispatch(printDepositSuccess(response.pdf));
      } else {
        dispatch(showErrorMessage(response.errors));
      }
    });
  };
}

export function printDepositSuccess(pdf) {
  return {
    type: DEPOSITS_DEPOSIT_PRINT_SUCCESS,
    payload: pdf,
  };
}

export function closePdfViewer() {
  return {
    type: DEPOSITS_DEPOSIT_PDF_VIEWER_CLOSE,
  };
}

export function loadUsersRequest(clientId) {
  return (dispatch) => {
    return clientsApi.getUsers(clientId).then((response) => {
      if (response.ok) {
        dispatch(loadUsersSuccess(clientId, response.users));
      } else {
        dispatch(showErrorMessage(response.errors));
      }
    });
  };
}

export function loadUsersSuccess(clientId, users) {
  return {
    type: DEPOSITS_USERS_LOAD_SUCCESS,
    payload: { clientId, users },
  };
}

export function sendEmail(depositId, emails, subject, message) {
  return (dispatch) => {
    return depositsApi
      .sendEmail(depositId, emails, subject, message)
      .then((response) => {
        if (response.ok) {
          dispatch(setShowEmailModal(false));
        } else {
          dispatch(showErrorMessage(response.errors));
        }

        return response;
      });
  };
}

export function setShowEmailModal(value) {
  return {
    type: DEPOSITS_DEPOSIT_EMAIL_MODAL_SHOW_SET,
    payload: value,
  };
}



// WEBPACK FOOTER //
// ./src/actions/admin/deposits/deposits.js